import request from '@/utils/zsm-requets'
const fund = '/zsm/api/fund/'
const fundReport = '/zsm/api/fundReport/'
const fundUser = '/zsm/api/fundUser/' // 新









/**
 *  讲师数据分析
 *  loginCode 登录账号
 *  afterDate 结束日期
 *  beforeDate   开始日期
 */
export function dataAnalysis(params) {
  return request({
    url: fundUser + 'dataAnalysis',
    method: 'post',
    params
  })
}


/**
 *  提交解绑申请
 *  id 解封的编号
 *  unfreezeApplyReason 申请解冻原因
 *  unfreezeApplyVoucher   申请解冻凭证
 *  unfreezeApplyDate   申请解冻时间
 */
export function unfreezeApply(params) {
  return request({
    url: fundUser + 'unfreezeApply',
    method: 'post',
    params
  })
}

/**
 *  查看某人的资金冻结记录
 *  userId 用户账号id
 *  beginDate 开始时间
 *  endDate   结束时间
 *  punishType 4 //类型
 *  pageNo 当前页
 * pageSize 每页条数
 */
export function findFreezeList(params) {
  return request({
    url: fundUser + 'findFreezeList',
    method: 'post',
    params
  })
}

/**
 *  某人的资金信息（新/总数据）
 *  id 用户账号id
 */
export function getFundUser(id) {
  return request({
    url: fundUser + 'get',
    method: 'post',
    params: { id }
  })
}

/**
 *  提现（新/总数据）
 *  bankId 银行卡编号
 *  loginCode 登录账号
 *  fee 提现金额
 */
export function withdrawFundUser(params) {
  return request({
    url: fundUser + 'withdraw',
    method: 'post',
    params
  })
}

/**
 *  讲师的资金日志（新/总数据）
 *  userId 登录账号
 *  bizDict 变动类型  dingdan_zhifu 收益   /  tixian 提现  / dingdan_fenzhang 订单分账
 */
export function listLogFundUser(params) {
  return request({
    url: fundUser + 'listLog',
    method: 'post',
    params
  })
}

/**
 *  某人某个时间段的统计数据
 *  id 用户账号id
 */
export function getListDataIntervalFundUser(params) {
  return request({
    url: fundUser + 'listDataInterval',
    method: 'post',
    params
  })
}

/**
 *  个人资金信息
 *  id 用户账号id
 */
export function getFund(id) {
  return request({
    url: fund + 'get',
    method: 'post',
    params: { id }
  })
}

/* 提现记录 */
export function withdrawList(params) {
  return request({
    url: fund + 'withdrawList',
    method: 'post',
    params
  })
}

/**
 *  达人的资金日志（新）根据开始时间结束时间查询统计数据
 *  @param   userId  登录账号
 *  @param   startDate 开始时间
 *  @param   endDate结束时间
 */
export function getFundUserByUserId(params) {
  return request({
    url: fundUser + 'getFundUserByUserId',
    method: 'post',
    params
  })
}

/* -----------以下接口已弃用------------- */

/**
 * -----------弃用------------
 *  讲师收益列表
 *  fee 收益金额
 *  distFlag 是否分销
 *  payFlag 是否支付
 *  withdrawFlag 提现状态
 *  bizId 订单号
 *  partnerId 用户
 */
export function incomeListFund(params) {
  return request({
    url: fund + 'incomeList',
    method: 'post',
    params
  })
}
/* -----------弃用------------
* 提现
* */
export function withdrawFund(params) {
  return request({
    url: fund + 'withdraw',
    method: 'post',
    params
  })
}

/* -----------弃用------------
*  获取某人某天资金数据 (新)
*/
export function getFundReport(params) {
  return request({
    url: fundReport + 'get',
    method: 'post',
    params
  })
}
/* -----------弃用------------
* 获取某人某个时间段内的数据
* */
export function listDataFundReport(params) {
  return request({
    url: fundReport + 'listData',
    method: 'post',
    params
  })
}
